/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cropper from 'react-easy-crop';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho/index.js';
import Rodape from '../../../../components/Rodape/index.js';
import CookieAceite from '../../../../components/CookieAceite/index.js';
import { 
    formatarCpfCnpj, 
    formatadorNumeroCelular,
    validadorCPF,
    validadorCNPJ,
    validadorEmail,
    validadorNomeCompleto,
    validadorNumeroCelular,
    validadorDataNascimento,
    removerCaracteresEspeciais,
    converterDataParaYMD,
    formatadorCPF,
    formatadorCNPJ
} from '../../../../utils/Validadores/index.js'

/*Import Requisição API*/
import api from '../../../../api.js';
import MenuLateral from '../../../../components/MenuLateral/index.js';
import { useCart } from '../../../../context/CartContext.js';

export default function Perfil() {

    const [id, setId] = useState('');
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [cpf_cnpj, setCpf_Cnpj] = useState('');
    const [celular, setCelular] = useState('');
    const [data_nascimento, setDataNascimento] = useState('');
    const [dataNascimentoRaw, setDataNascimentoRaw] = useState('');
    const [sexo, setSexo] = useState('');
    const [entro_em, setEntrouEm] = useState('');
    const [enderecos, setEnderecos] = useState([]);
    const [pedidos, setPedidos] = useState([]);
    const [fotoPerfil, setFotoPerfil] = useState('');
    const [texto, setTexto] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { resetCart } = useCart();
    const imagemPadrao = '/assets/image/imagemPadrao.svg';

    const [imagemParaCrop, setImagemParaCrop] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [modalCropAberto, setModalCropAberto] = useState(false);
    const caixaCrop = useRef(null);

    const [modalAberto, setModalAberto] = useState(false);
    const [idEnderecoParaExcluir, setIdEnderecoParaExcluir] = useState(null);
    const caixaDeDialogo = useRef(null);
    const caixaAlterarDados = useRef(null);

    const [modalAlterarDados, setModalAlterarDados] = useState(false);
    const [formNome, setFormNome] = useState('');
    const [formTelefone, setFormTelefone] = useState('');
    const [formDataNascimento, setFormDataNascimento] = useState('');
    const [formDataNascimentoRaw, setFormDataNascimentoRaw] = useState('');
    const [formSexo, setFormSexo] = useState('');
    const [formEmail, setFormEmail] = useState('');
    const [formCpfCnpj, setFormCpfCnpj] = useState('');

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
        caixaCrop.current = document.getElementById('CaixaCrop');
        caixaAlterarDados.current = document.getElementById('CaixaAlterarDados');
    }, []);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const createImage = (url) =>
        new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => resolve(image));
            image.addEventListener('error', (error) => reject(error));
            image.setAttribute('crossOrigin', 'anonymous');
            image.src = url;
        });

    const getCroppedImg = async (imageSrc, pixelCrop) => {
        const image = await createImage(imageSrc);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, 'image/jpeg');
        });
    };

    const abrirModalExcluir = (id_endereco) => {
        setIdEnderecoParaExcluir(id_endereco);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
        setIdEnderecoParaExcluir(null);
    };


    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);

                if (response.data.success) {
                    console.log('Passei aqui');
                    setId(response.data.user.id);
                    setNome(response.data.user.nome);
                    setEmail(response.data.user.email);
                    setCpf_Cnpj(response.data.user.cpf_cnpj);
                    setCelular(response.data.user.celular);
                    setDataNascimentoRaw(response.data.user.data_nascimento);

                    // Formatar data sem timezone issues
                    if (response.data.user.data_nascimento) {
                        const dataStr = response.data.user.data_nascimento.split('T')[0];
                        const [ano, mes, dia] = dataStr.split('-');
                        setDataNascimento(`${dia}/${mes}/${ano}`);
                    }

                    setSexo(response.data.user.sexo);
                    
                    // Formatar data de criação
                    if (response.data.user.criada_em) {
                        const [anoC, mesC, diaC] = response.data.user.criada_em.split('T')[0].split('-');
                        setEntrouEm(`${diaC}/${mesC}/${anoC}`);
                    }
                    
                    setFotoPerfil(response.data.user.foto_perfil || imagemPadrao);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                setId(null);
                setNome(null);
                setEmail(null);
                setCpf_Cnpj(null);
                setCelular(null);
                setDataNascimento(null);
            } finally {
                setLoading(false);
            }
        };

        buscarDadosUsuario();
    }, []);

    useEffect(() => {
        const fetchEnderecos = async () => {
            if (!id) return;
            try {
                const response = await api.get(`/enderecos/${id}`);
                setEnderecos(response.data.data);
            } catch (error) {
                console.error('Erro ao buscar endereços:', error);
            }
        };

        fetchEnderecos();
    }, [id]);

    useEffect(() => {
        const fetchPedidos = async () => {
            if (!id) return;
            try {
                const response = await api.get(`/usuario/${id}/pedidos`, { withCredentials: true });
                if (response.data.success) {
                    // Pegar apenas os últimos 3 pedidos
                    const ultimosPedidos = response.data.data.slice(0, 3);
                    setPedidos(ultimosPedidos);
                }
            } catch (error) {
                console.error('Erro ao buscar pedidos:', error);
            }
        };

        fetchPedidos();
    }, [id]);

    const confirmarExcluirEndereco = async () => {
        try {
            console.log('Excluindo endereço com ID:', idEnderecoParaExcluir);
            await api.delete(`/endereco/${idEnderecoParaExcluir}`, { id_usuario: id });
            setEnderecos(enderecos.filter(endereco => endereco.id !== idEnderecoParaExcluir));
            fecharModal();
        } catch (error) {
            console.error('Erro ao excluir endereço:', error);
            fecharModal();
        }
    };

    const editarEndereco = (id_endereco) => {
        console.log('Editar endereço com ID:', id_endereco);
        navigate('/menu/perfil/alterarendereco', { state: { idEndereco: id_endereco } });
    };

    const handleImagemChange = (event) => {
        const novaImagem = event.target.files[0];
        if (!novaImagem) return;

        const tiposPermitidos = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
        if (!tiposPermitidos.includes(novaImagem.type)) {
            alert('Tipo de arquivo inválido. Use apenas JPEG, PNG ou WEBP.');
            return;
        }

        const tamanhoMaximo = 5 * 1024 * 1024; // 5MB
        if (novaImagem.size > tamanhoMaximo) {
            alert('Arquivo muito grande. O tamanho máximo é 5MB.');
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            setImagemParaCrop(reader.result);
            setModalCropAberto(true);
            if (caixaCrop.current) {
                caixaCrop.current.showModal();
            }
        };
        reader.readAsDataURL(novaImagem);
    };

    const fecharModalCrop = () => {
        if (caixaCrop.current) {
            caixaCrop.current.close();
        }
        setModalCropAberto(false);
        setImagemParaCrop(null);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
    };

    const confirmarCrop = async () => {
        try {
            const croppedBlob = await getCroppedImg(imagemParaCrop, croppedAreaPixels);

            const formData = new FormData();
            formData.append('foto_perfil', croppedBlob, 'perfil.jpg');

            const response = await api.post(`/usuario/${id}/foto-perfil`, formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                console.log('Foto de perfil atualizada com sucesso:', response.data.url);
                setFotoPerfil(response.data.url);
                fecharModalCrop();
            }
        } catch (error) {
            console.error('Erro ao atualizar foto de perfil:', error);
            alert('Erro ao atualizar foto de perfil. Tente novamente.');
        }
    };

    const handleLogout = async () => {
        try {
            await api.post('/api/logout', {}, { withCredentials: true });
            resetCart();
            navigate('/login');
        } catch (error) {
            console.error('Erro ao fazer logout:', error);
        }
    };

    const cadastroEndereco = async () => {
        navigate('/menu/perfil/cadastroendereco')
    }

    const abrirModalAlterarDados = async () => {
        try {
            // Buscar dados completos (sem mascaramento) para edição
            const response = await api.get('/usuario/editar', { withCredentials: true });
            
            if (response.data.success) {
                const dadosCompletos = response.data.user;
                
                setFormNome(dadosCompletos.nome || '');
                setFormEmail(dadosCompletos.email || '');
                setFormSexo(dadosCompletos.sexo || '');
                
                // Usar CPF/CNPJ completo retornado do endpoint de edição
                if (dadosCompletos.cpf_cnpj && dadosCompletos.cpf_cnpj.trim()) {
                    const cpfCnpjLimpo = removerCaracteresEspeciais(dadosCompletos.cpf_cnpj);
                    const cpfCnpjFormatado = cpfCnpjLimpo.length === 11 ? formatadorCPF(cpfCnpjLimpo) : formatadorCNPJ(cpfCnpjLimpo);
                    setFormCpfCnpj(cpfCnpjFormatado);
                } else {
                    setFormCpfCnpj('');
                }
                
                // Mostrar telefone formatado no input
                if (dadosCompletos.celular && dadosCompletos.celular.trim()) {
                    setFormTelefone(formatadorNumeroCelular(dadosCompletos.celular));
                } else {
                    setFormTelefone('');
                }
                
                // Formatar data para exibição no input (DD/MM/AAAA)
                if (dadosCompletos.data_nascimento && dadosCompletos.data_nascimento.trim()) {
                    try {
                        const dataStr = dadosCompletos.data_nascimento.includes('T') ? dadosCompletos.data_nascimento.split('T')[0] : dadosCompletos.data_nascimento;
                        const [ano, mes, dia] = dataStr.split('-');
                        setFormDataNascimento(`${dia}/${mes}/${ano}`);
                    } catch (error) {
                        console.error('Erro ao formatar data:', error);
                        setFormDataNascimento('');
                    }
                } else {
                    setFormDataNascimento('');
                }

                if (caixaAlterarDados.current) {
                    caixaAlterarDados.current.showModal();
                    setModalAlterarDados(true);
                }
            }
        } catch (error) {
            console.error('Erro ao buscar dados para edição:', error);
            alert('Erro ao carregar dados para edição. Tente novamente.');
        }
    };

    const fecharModalAlterarDados = () => {
        if (caixaAlterarDados.current) {
            caixaAlterarDados.current.close();
        }
        setModalAlterarDados(false);
    };

    const handleDataNascimentoChange = (e) => {
        let valor = e.target.value.replace(/\D/g, '');
        if (valor.length > 2 && valor.length <= 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2)}`;
        } else if (valor.length > 4) {
            valor = `${valor.slice(0, 2)}/${valor.slice(2, 4)}/${valor.slice(4, 8)}`;
        }
        setFormDataNascimento(valor);
    };

    const handleTelefoneChange = (e) => {
        const valor = e.target.value.replace(/\D/g, '');
        let valorFormatado = valor;
        if (valor.length <= 11) {
            valorFormatado = formatadorNumeroCelular(valor);
        }
        setFormTelefone(valorFormatado);
    };

    const handleCpfOuCnpjChange = (e) => {
        const { value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');

        let valorFormatado = sanitizedValue;

        if (sanitizedValue.length <= 11) {
            valorFormatado = formatadorCPF(sanitizedValue);
        } else if (sanitizedValue.length <= 14) {
            valorFormatado = formatadorCNPJ(sanitizedValue);
        }

        setFormCpfCnpj(valorFormatado);
    };

    const salvarAlteracoes = async (event) => {
        event.preventDefault();
        console.log('=== Iniciando salvarAlteracoes ===');
        console.log('Form Email:', formEmail);
        console.log('Form Telefone:', formTelefone);
        console.log('Form CPF/CNPJ:', formCpfCnpj);
        console.log('Form Sexo:', formSexo);
        console.log('Form Data Nascimento:', formDataNascimento);

        // Validações rigorosas
        const cpfCnpjLimpo = removerCaracteresEspeciais(formCpfCnpj);
        const celularLimpo = removerCaracteresEspeciais(formTelefone);
        const emailValido = validadorEmail(formEmail);
        const celularValido = validadorNumeroCelular(celularLimpo);
        const isCpf = cpfCnpjLimpo.length === 11;
        const cpfOuCnpjValido = isCpf ? validadorCPF(cpfCnpjLimpo) : validadorCNPJ(cpfCnpjLimpo);

        // Validar CPF/CNPJ
        if (!cpfCnpjLimpo || cpfCnpjLimpo.length === 0) {
            setTexto("CPF ou CNPJ é obrigatório.");
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        if (cpfCnpjLimpo.length !== 11 && cpfCnpjLimpo.length !== 14) {
            setTexto("CPF deve ter 11 dígitos e CNPJ deve ter 14 dígitos.");
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        if (!cpfOuCnpjValido) {
            setTexto(`${isCpf ? 'CPF' : 'CNPJ'} inválido.`);
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        // Validar Email
        if (!formEmail || formEmail.trim() === '') {
            setTexto("E-mail é obrigatório.");
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        if (!emailValido) {
            setTexto("E-mail inválido.");
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        // Validar Telefone
        if (!celularLimpo || celularLimpo.length === 0) {
            setTexto("Número de celular é obrigatório.");
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        if (!celularValido) {
            setTexto("Número de celular inválido. Deve conter 11 dígitos.");
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
            return;
        }

        // Validar Data de Nascimento
        if (formDataNascimento) {
            const dataValida = validadorDataNascimento(formDataNascimento);
            if (!dataValida) {
                setTexto("Data de nascimento inválida ou menor de 18 anos.");
                if (caixaDeDialogo.current) {
                    caixaDeDialogo.current.showModal();
                }
                return;
            }
        }

        try {
            let dataNascimentoConvertida = null;
            if (formDataNascimento) {
                dataNascimentoConvertida = converterDataParaYMD(formDataNascimento);
            }

            console.log('📤 Enviando para API:', {
                cpf_cnpj: cpfCnpjLimpo,
                email: formEmail.toLowerCase().trim(),
                celular: celularLimpo,
                data_nascimento: dataNascimentoConvertida,
                sexo: formSexo
            });

            console.log('🔗 URL da API:', `/usuario/${id}`);
            console.log('👤 ID do usuário:', id);
            console.log('⏳ Aguardando resposta da API...');

            const response = await api.put(
                `/cliente/${id}`,
                {
                    cpf_cnpj: cpfCnpjLimpo,
                    email: formEmail.toLowerCase().trim(),
                    celular: celularLimpo,
                    data_nascimento: dataNascimentoConvertida,
                    sexo: formSexo
                },
                { withCredentials: true }
            );

            console.log('✅ Resposta da API recebida!');
            console.log('Response completo:', response);
            console.log('Response.data:', response.data);

            if (response.data.success) {
                console.log('🎉 Sucesso! Atualizando estados locais...');
                
                // Atualizar estados locais com dados do backend
                if (response.data.usuario) {
                    const usuario = response.data.usuario;
                    setCelular(usuario.celular);
                    setEmail(usuario.email);
                    setSexo(usuario.sexo);
                    setCpf_Cnpj(usuario.cpf_cnpj);
                    
                    if (usuario.data_nascimento) {
                        const dataStr = usuario.data_nascimento.includes('T') ? usuario.data_nascimento.split('T')[0] : usuario.data_nascimento;
                        const [ano, mes, dia] = dataStr.split('-');
                        setDataNascimento(`${dia}/${mes}/${ano}`);
                        setDataNascimentoRaw(usuario.data_nascimento);
                    }
                }
                
                // Fechar modal
                fecharModalAlterarDados();
                
                setTexto("Dados atualizados com sucesso!");
                if (caixaDeDialogo.current) {
                    caixaDeDialogo.current.showModal();
                }
            } else {
                console.log('⚠️ API retornou success=false');
                fecharModalAlterarDados();
                setTexto(response.data.message || "Erro ao atualizar dados.");
                if (caixaDeDialogo.current) {
                    caixaDeDialogo.current.showModal();
                }
            }
        } catch (error) {
            console.error('❌ ERRO ao atualizar dados:', error);
            console.error('Tipo do erro:', error.constructor.name);
            console.error('Mensagem:', error.message);
            console.error('Response:', error.response);
            console.error('Status:', error.response?.status);
            console.error('Data:', error.response?.data);
            console.error('Stack:', error.stack);
            
            fecharModalAlterarDados();
            
            const mensagemErro = error.response?.data?.message || error.message || "Erro ao atualizar dados. Tente novamente mais tarde.";
            setTexto(mensagemErro);
            if (caixaDeDialogo.current) {
                caixaDeDialogo.current.showModal();
            }
        }
    };

    return (
        <section className='container-principal-perfil'>
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto || "Você deseja excluir esse endereço?"}</p>
                        <div className='bnts-decisao'>
                            {texto ? (
                                <button className="bnt-sim" onClick={fecharModal}>
                                    Ok
                                </button>
                            ) : (
                                <>
                                    <button className="bnt-sim" onClick={confirmarExcluirEndereco}>
                                        Sim
                                    </button>
                                    <button className="bnt-nao" onClick={fecharModal}>
                                        Não
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaAlterarDados" className={modalAlterarDados ? 'open' : ''}>
                <div className='conteudo-dialog alterar-dados'>
                    <div className='dialog-texto'>
                        <h2>Alterar dados</h2>
                        <form className='form-alterar-dados'>
                            <label>Nome: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={formNome}
                                    onChange={(e) => setFormNome(e.target.value)}
                                    placeholder="Nome completo"
                                    disabled
                                    required
                                />
                            </div>

                            <label>Celular: <span className="span-obrigatorio">*</span></label>
                            <div className="input-celular">
                                <input
                                    type="text"
                                    value={formTelefone}
                                    onChange={handleTelefoneChange}
                                    placeholder="(11) 9XXXX-XXXX"
                                    required
                                />
                            </div>
                            <label>Data de Nascimento:<span className="span-obrigatorio">*</span></label>
                            <div className="input-dataNascimento">
                                <input
                                    type="text"
                                    value={formDataNascimento}
                                    onChange={handleDataNascimentoChange}
                                    placeholder="DD/MM/AAAA"
                                    maxLength="10"
                                />
                            </div>
                            <label>Sexo:<span className="span-obrigatorio">*</span></label>
                            <div className="input-sexo">
                                <select value={formSexo} onChange={(e) => setFormSexo(e.target.value)} required>
                                    <option value="">Selecione</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Feminino">Feminino</option>
                                    <option value="Outro">Outro</option>
                                </select>
                            </div>
                            <label>E-mail: <span className="span-obrigatorio">*</span></label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={formEmail}
                                    onChange={(e) => setFormEmail(e.target.value)}
                                    placeholder="Digite o e-mail"
                                    required
                                />
                            </div>
                            <label>CPF/CNPJ: <span className="span-obrigatorio">*</span></label>
                            <div className="input-CpfOuCnpj">
                                <input
                                    type="text"
                                    value={formCpfCnpj}
                                    onChange={handleCpfOuCnpjChange}
                                    placeholder="Digite CPF ou CNPJ"
                                />
                            </div>
                            <div className='bnts-decisao'>
                                <button type='submit' className='bnt-sim' onClick={salvarAlteracoes}>
                                    Salvar
                                </button>
                                <button type='button' className='bnt-nao' onClick={fecharModalAlterarDados}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </dialog>

            <dialog id="CaixaCrop" className={modalCropAberto ? 'open modal-crop' : 'modal-crop'}>
                <div className='conteudo-crop'>
                    <h2>Ajustar Foto de Perfil</h2>
                    <div className='crop-container'>
                        {imagemParaCrop && (
                            <Cropper
                                image={imagemParaCrop}
                                crop={crop}
                                zoom={zoom}
                                aspect={1}
                                cropShape="round"
                                showGrid={false}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        )}
                    </div>
                    <div className='crop-controls'>
                        <label>Zoom:</label>
                        <input
                            type="range"
                            min={1}
                            max={3}
                            step={0.1}
                            value={zoom}
                            onChange={(e) => setZoom(Number(e.target.value))}
                        />
                    </div>
                    <div className='bnts-crop'>
                        <button className="bnt-cancelar" onClick={fecharModalCrop}>
                            Cancelar
                        </button>
                        <button className="bnt-confirmar" onClick={confirmarCrop}>
                            Confirmar
                        </button>
                    </div>
                </div>
            </dialog>
            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-perfil'>

                    {loading ? (
                        <div className='loading-perfil'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path>
                            </svg>
                            <h2>Carregando perfil...</h2>
                        </div>
                    ) : (
                    <>

                    <div className='titulo-perfil'>
                        <h1>Perfil</h1>
                    </div>
                    <div className='perfil-ferramentas'>
                        <div className='perfil-informacoes'>
                            <label className='imagem-perfil'>
                                <img src={fotoPerfil || imagemPadrao} alt="Foto de perfil" />
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImagemChange}
                                    style={{ display: 'none' }}
                                />
                                <span className="icone-camera">
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.63636 17C2.18636 17 1.80127 16.8435 1.48109 16.5304C1.16091 16.2173 1.00055 15.8405 1 15.4V5.8C1 5.36 1.16036 4.98347 1.48109 4.6704C1.80182 4.35733 2.18691 4.20053 2.63636 4.2H5.21364L6.72727 2.6H11.6364V4.2H7.44318L5.95 5.8H2.63636V15.4H15.7273V8.2H17.3636V15.4C17.3636 15.84 17.2035 16.2168 16.8834 16.5304C16.5632 16.844 16.1778 17.0005 15.7273 17H2.63636ZM15.7273 5.8V4.2H14.0909V2.6H15.7273V1H17.3636V2.6H19V4.2H17.3636V5.8H15.7273ZM9.18182 14.2C10.2045 14.2 11.074 13.8501 11.7902 13.1504C12.5064 12.4507 12.8642 11.6005 12.8636 10.6C12.8631 9.59947 12.5053 8.7496 11.7902 8.0504C11.0751 7.3512 10.2056 7.00107 9.18182 7C8.158 6.99893 7.28882 7.34907 6.57427 8.0504C5.85973 8.75173 5.50164 9.6016 5.5 10.6C5.49836 11.5984 5.85645 12.4485 6.57427 13.1504C7.29209 13.8523 8.16127 14.2021 9.18182 14.2ZM9.18182 12.6C8.60909 12.6 8.125 12.4067 7.72955 12.02C7.33409 11.6333 7.13636 11.16 7.13636 10.6C7.13636 10.04 7.33409 9.56667 7.72955 9.18C8.125 8.79333 8.60909 8.6 9.18182 8.6C9.75455 8.6 10.2386 8.79333 10.6341 9.18C11.0295 9.56667 11.2273 10.04 11.2273 10.6C11.2273 11.16 11.0295 11.6333 10.6341 12.02C10.2386 12.4067 9.75455 12.6 9.18182 12.6Z" fill="black" stroke="black" stroke-width="0.75" />
                                    </svg>

                                </span>
                            </label>
                            <div className='texto-perfil'>
                                <h2>Olá, {nome}!</h2>
                                <h3><span>Email:</span> {email}</h3>
                                <h3><span>{cpf_cnpj && cpf_cnpj.length === 14 ? 'CPF:' : 'CNPJ:'}</span> {cpf_cnpj ? formatarCpfCnpj(cpf_cnpj) : 'N/A'}</h3>
                                <h3><span>Celular:</span> {celular ? formatadorNumeroCelular(celular) : 'N/A'}</h3>
                                {/* </p>
                                <p><span>Data de Nascimento:</span> {data_nascimento}</p>
                                <p><span>Sexo:</span> {sexo}</p>
                                <p><span>Ingressou em:</span> {entro_em}</p> */}
                            </div>
                        </div>
                        <div className='perfil-atalho'>
                            <div className='conteudo-perfil-atalho'>
                                <Link to='/menu/perfil/meuspedidos' className='bnt-meus-pedidos'><div className='conteudo-ferramenta'><svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1667 1.33337H2.83341C1.91294 1.33337 1.16675 2.07957 1.16675 3.00004V13.8334C1.16675 14.7538 1.91294 15.5 2.83341 15.5H11.1667C12.0872 15.5 12.8334 14.7538 12.8334 13.8334V3.00004C12.8334 2.07957 12.0872 1.33337 11.1667 1.33337Z" stroke="black" stroke-width="1.66667" /><path d="M4.5 5.5H9.5M4.5 8.83333H9.5M4.5 12.1667H7.83333" stroke="black" stroke-width="1.66667" stroke-linecap="round" /></svg>Meus Pedidos</div> <img src='/assets/image/seta.svg' /></Link>
                                <Link to='/menu/perfil/favoritos' className='bnt-favoritos'><div className='conteudo-ferramenta'><svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.33895 7.80635L8.01243 12.7177C8.20829 12.8869 8.30622 12.9719 8.42047 12.9929C8.47248 13.0024 8.52597 13.0024 8.57798 12.9929C8.69386 12.9719 8.79098 12.8876 8.98602 12.7177L14.6603 7.8071C15.431 7.14028 15.9041 6.23252 15.9869 5.26135C16.0698 4.29017 15.7565 3.32545 15.1084 2.55584L14.8554 2.25579C13.2493 0.348703 10.0257 0.668306 8.89707 2.84762C8.86117 2.91668 8.8048 2.97498 8.73448 3.01579C8.66415 3.0566 8.58274 3.07826 8.49963 3.07826C8.41653 3.07826 8.33511 3.0566 8.26479 3.01579C8.19447 2.97498 8.1381 2.91668 8.1022 2.84762C6.97354 0.668306 3.74997 0.347951 2.1439 2.25579L1.89092 2.55659C1.24323 3.32609 0.930223 4.29049 1.01308 5.26132C1.09593 6.23214 1.56869 7.1396 2.33895 7.80635Z" stroke="black" stroke-width="1.75" /></svg>Favoritos</div><img src='/assets/image/seta.svg' /></Link>
                                <button className='bnt-alterar-dados' onClick={abrirModalAlterarDados}><div className='conteudo-ferramenta'><svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33325 4C1.33325 5.38083 4.31825 6.5 7.99992 6.5C11.6816 6.5 14.6666 5.38083 14.6666 4C14.6666 2.61917 11.6816 1.5 7.99992 1.5C4.31825 1.5 1.33325 2.61917 1.33325 4Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" /><path d="M1.33325 4V9C1.33325 10.3808 4.31825 11.5 7.99992 11.5C8.39881 11.5 8.78825 11.4872 9.16825 11.4617M14.6666 9V4" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" /><path d="M1.33325 9V14C1.33325 15.2717 3.86659 16.3217 7.14325 16.4792M13.3499 12.0083C13.6781 11.6801 14.1233 11.4957 14.5874 11.4957C15.0516 11.4957 15.4967 11.6801 15.8249 12.0083C16.1531 12.3365 16.3375 12.7817 16.3375 13.2458C16.3375 13.71 16.1531 14.1551 15.8249 14.4833L12.9999 17.3333H10.4999V14.8333L13.3499 12.0083Z" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" /></svg>Alterar Dados</div> <img src='/assets/image/seta.svg' /></button>
                                <Link to='/contato' className='bnt-ajuda-suporte'><div className='conteudo-ferramenta'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0001 18.3333C11.0946 18.3346 12.1787 18.1197 13.1899 17.7008C14.2011 17.282 15.1196 16.6674 15.8926 15.8925C16.6675 15.1195 17.2821 14.201 17.701 13.1898C18.1198 12.1785 18.3348 11.0945 18.3334 9.99997C18.3348 8.90542 18.1198 7.82139 17.701 6.81017C17.2821 5.79895 16.6675 4.88045 15.8926 4.10747C15.1196 3.33253 14.2011 2.71797 13.1899 2.2991C12.1787 1.88022 11.0946 1.66528 10.0001 1.66663C8.90554 1.66528 7.82152 1.88022 6.81029 2.2991C5.79907 2.71797 4.88058 3.33253 4.10759 4.10747C3.33265 4.88045 2.7181 5.79895 2.29922 6.81017C1.88034 7.82139 1.6654 8.90542 1.66675 9.99997C1.6654 11.0945 1.88034 12.1785 2.29922 13.1898C2.7181 14.201 3.33265 15.1195 4.10759 15.8925C4.88058 16.6674 5.79907 17.282 6.81029 17.7008C7.82152 18.1197 8.90554 18.3346 10.0001 18.3333Z" stroke="black" stroke-width="2" stroke-linejoin="round" /><path d="M10 11.927V10.2604C10.4945 10.2604 10.9778 10.1138 11.3889 9.83905C11.8 9.56435 12.1205 9.1739 12.3097 8.71709C12.4989 8.26027 12.5484 7.7576 12.452 7.27265C12.3555 6.7877 12.1174 6.34224 11.7678 5.99261C11.4181 5.64298 10.9727 5.40488 10.4877 5.30841C10.0028 5.21195 9.50011 5.26146 9.04329 5.45068C8.58648 5.6399 8.19603 5.96033 7.92133 6.37145C7.64662 6.78257 7.5 7.26592 7.5 7.76038" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 15.6771C10.2764 15.6771 10.5414 15.5673 10.7367 15.372C10.9321 15.1766 11.0418 14.9117 11.0418 14.6354C11.0418 14.3591 10.9321 14.0942 10.7367 13.8988C10.5414 13.7035 10.2764 13.5938 10.0002 13.5938C9.7239 13.5938 9.45894 13.7035 9.26359 13.8988C9.06824 14.0942 8.9585 14.3591 8.9585 14.6354C8.9585 14.9117 9.06824 15.1766 9.26359 15.372C9.45894 15.5673 9.7239 15.6771 10.0002 15.6771Z" fill="black" /></svg>Ajuda e Suporte</div> <img src='/assets/image/seta.svg' /></Link>
                                <button className='bnt-sair' onClick={handleLogout}><svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.375 34.375C3.34375 34.375 2.46125 34.0081 1.7275 33.2744C0.99375 32.5406 0.62625 31.6575 0.625 30.625V4.375C0.625 3.34375 0.9925 2.46125 1.7275 1.7275C2.4625 0.99375 3.345 0.62625 4.375 0.625H15.625C16.1562 0.625 16.6019 0.805 16.9619 1.165C17.3219 1.525 17.5012 1.97 17.5 2.5C17.4988 3.03 17.3187 3.47562 16.96 3.83687C16.6012 4.19812 16.1562 4.3775 15.625 4.375H4.375V30.625H15.625C16.1562 30.625 16.6019 30.805 16.9619 31.165C17.3219 31.525 17.5012 31.97 17.5 32.5C17.4988 33.03 17.3187 33.4756 16.96 33.8369C16.6012 34.1981 16.1562 34.3775 15.625 34.375H4.375ZM27.2031 19.375H13.75C13.2188 19.375 12.7738 19.195 12.415 18.835C12.0563 18.475 11.8762 18.03 11.875 17.5C11.8738 16.97 12.0538 16.525 12.415 16.165C12.7763 15.805 13.2212 15.625 13.75 15.625H27.2031L23.6875 12.1094C23.3438 11.7656 23.1719 11.3438 23.1719 10.8438C23.1719 10.3438 23.3438 9.90625 23.6875 9.53125C24.0313 9.15625 24.4688 8.96063 25 8.94438C25.5312 8.92813 25.9844 9.10813 26.3594 9.48438L33.0625 16.1875C33.4375 16.5625 33.625 17 33.625 17.5C33.625 18 33.4375 18.4375 33.0625 18.8125L26.3594 25.5156C25.9844 25.8906 25.5394 26.0706 25.0244 26.0556C24.5094 26.0406 24.0638 25.845 23.6875 25.4688C23.3438 25.0938 23.18 24.6488 23.1963 24.1338C23.2125 23.6188 23.3919 23.1888 23.7344 22.8438L27.2031 19.375Z" /></svg>Sair</button>
                            </div>
                            <div className='conteudo-perfil-endereco-compras'>
                                <div className='conteudo-endereco'>
                                    <p className='titulo-endereco'><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33341 11.75L10.8334 12.5834C10.8334 12.5834 17.0834 11.3334 17.9167 11.3334C18.7501 11.3334 18.7501 12.1667 17.9167 13C17.0834 13.8334 14.1667 16.3334 11.6667 16.3334C9.16675 16.3334 7.50008 15.0834 5.83341 15.0834H1.66675" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M1.66675 10.0834C2.50008 9.25004 4.16675 8.00004 5.83341 8.00004C7.50008 8.00004 11.4584 9.66671 12.0834 10.5C12.7084 11.3334 10.8334 12.5834 10.8334 12.5834M6.66675 5.50004V2.16671C6.66675 1.94569 6.75455 1.73373 6.91083 1.57745C7.06711 1.42117 7.27907 1.33337 7.50008 1.33337H17.5001C17.7211 1.33337 17.9331 1.42117 18.0893 1.57745C18.2456 1.73373 18.3334 1.94569 18.3334 2.16671V8.83337" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M10.4167 1.33337H14.5834V5.08337H10.4167V1.33337Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>Endereços de Entrega</p>
                                    <div className='container-enderecos'>
                                        {enderecos.length > 0 ? (
                                            enderecos.map((endereco) => (
                                                <div key={endereco.id} className='endereco-item'>
                                                    <p className='info-endereco'>{`${endereco.logradouro}, ${endereco.numero}, ${endereco.bairro}, ${endereco.cidade} - ${endereco.estado}`}</p>
                                                    <div className='botoes-endereco'>
                                                        <button
                                                            className='bnt-editar'
                                                            onClick={() => editarEndereco(endereco.id)}>
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </button>
                                                        <button
                                                            className='bnt-excluir'
                                                            onClick={() => abrirModalExcluir(endereco.id)}>
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className='texto-nenhumEndereco'>Nenhum endereço cadastrado.</p>
                                        )}
                                    </div>
                                    <button className='bnt-adicionar-endereco' onClick={cadastroEndereco}>+ Adicionar Endereço</button>
                                </div>
                                <div className='conteudo-compras'>
                                    <p className='titulo-compras'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.75591 1.91079C9.59967 1.7545 9.38774 1.66667 9.16675 1.66663H5.00008C4.77909 1.66667 4.56716 1.7545 4.41091 1.91079L1.91091 4.41079C1.75462 4.56704 1.6668 4.77896 1.66675 4.99996V9.16663C1.66675 9.38829 1.75425 9.59996 1.91091 9.75579L10.2442 18.0891C10.3215 18.1668 10.4133 18.2284 10.5144 18.2705C10.6155 18.3125 10.7239 18.3342 10.8334 18.3342C10.9429 18.3342 11.0513 18.3125 11.1525 18.2705C11.2536 18.2284 11.3454 18.1668 11.4226 18.0891L18.0892 11.4225C18.2455 11.2662 18.3332 11.0543 18.3332 10.8333C18.3332 10.6123 18.2455 10.4004 18.0892 10.2441L9.75591 1.91079ZM10.8334 16.3216L3.33341 8.82163V5.34496L5.34508 3.33329H8.82175L16.3217 10.8333L10.8334 16.3216Z" fill="black" stroke="black" />
                                        <path d="M6.96088 8.33338C7.71889 8.33338 8.33338 7.71889 8.33338 6.96088C8.33338 6.20287 7.71889 5.58838 6.96088 5.58838C6.20287 5.58838 5.58838 6.20287 5.58838 6.96088C5.58838 7.71889 6.20287 8.33338 6.96088 8.33338Z" fill="black" stroke="black" />
                                    </svg>
                                        Últimas compras</p>
                                    <div className='container-compras'>
                                        {pedidos.length > 0 ? (
                                            pedidos.map((pedido) => (
                                                <div key={pedido.id} className='compras-item'>
                                                    <div className='info-compra-container'>
                                                        <p className='info-compra'>
                                                            <span>Pedido #{pedido.id}</span> - {new Date(pedido.data_pedido).toLocaleDateString('pt-BR')}<br />
                                                            <span>Status:</span> {pedido.status_pedido}<br />
                                                            <span>Total:</span> R$ {Number(pedido.valor_total).toFixed(2)}
                                                        </p>
                                                    </div>
                                                    <Link to={`/menu/perfil/meuspedidos/${pedido.id}`} className='bnt-ver-detalhes'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 6.5625C8.4375 6.31527 8.51081 6.0736 8.64817 5.86804C8.78552 5.66248 8.98074 5.50226 9.20915 5.40765C9.43756 5.31304 9.68889 5.28829 9.93137 5.33652C10.1738 5.38475 10.3966 5.5038 10.5714 5.67862C10.7462 5.85343 10.8653 6.07616 10.9135 6.31864C10.9617 6.56111 10.937 6.81245 10.8424 7.04085C10.7477 7.26926 10.5875 7.46449 10.382 7.60184C10.1764 7.73919 9.93473 7.8125 9.6875 7.8125C9.35598 7.8125 9.03804 7.6808 8.80362 7.44638C8.5692 7.21196 8.4375 6.89402 8.4375 6.5625ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31039 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10ZM10.9375 12.8656V10.3125C10.9375 9.8981 10.7729 9.50067 10.4799 9.20765C10.1868 8.91462 9.7894 8.75 9.375 8.75C9.1536 8.74967 8.93923 8.82771 8.76986 8.97029C8.60048 9.11287 8.48703 9.3108 8.4496 9.52901C8.41217 9.74722 8.45318 9.97164 8.56536 10.1625C8.67754 10.3534 8.85365 10.4984 9.0625 10.5719V13.125C9.0625 13.5394 9.22712 13.9368 9.52015 14.2299C9.81317 14.5229 10.2106 14.6875 10.625 14.6875C10.8464 14.6878 11.0608 14.6098 11.2302 14.4672C11.3995 14.3246 11.513 14.1267 11.5504 13.9085C11.5878 13.6903 11.5468 13.4659 11.4346 13.275C11.3225 13.0841 11.1464 12.9391 10.9375 12.8656Z" stroke-width="0.3" /></svg>
                                                    </Link>
                                                </div>
                                            ))
                                        ) : (
                                            <p className='texto-nenhumaCompra'>Ainda não há compras registradas</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </>
                    )}
                </section>
            </main>

            <Rodape />

        </section>
    );
}
